module.exports = __webpack_public_path__ + "img/Skirt-Front-B7-Db-Fb-Hc-Ia.d8ed02fe.png";